export default __webpack_public_path__ + "static/media/prasadam.86a68751.svg";